<script>
import {defineComponent} from 'vue'
import CommonPage from "@/components/echarts-part/stuff/CommonPage.vue";
import BomTree from "@/components/bom/BomTree.vue";

export default defineComponent({
    name: "BomTreePage",
    components: {BomTree, CommonPage},
    data() {
        return {
            needWarning: false
        }
    },
    beforeRouteLeave(to, from, next) {
        if (this.needWarning) {
            let leave = confirm('离开后页面内容将清空，确认离开？');
            if (leave) {
                next(true);
            } else {
                next(false);
            }
        } else {
            next(true)
        }
    }
})
</script>

<template>
    <common-page>
        <BomTree @gotBom="needWarning=true"></BomTree>
    </common-page>
</template>

<style scoped>

</style>